import axios, { AxiosInstance } from 'axios';
import { BASE_URL, API_REQUEST_TIMEOUT, CLIENT_NAME, CLIENT_PLATFORM } from '../constants/environment.constant';
import { storageService } from './storageService';
import { authService } from './authService';

// Origin signals sent on every request, read by the backend clientContext
// middleware (req.clientName / req.clientPlatform).
const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
  'x-client-name': CLIENT_NAME,
  'x-client-platform': CLIENT_PLATFORM,
};

export class AxiosService {
  private publicAxiosInstance: AxiosInstance;
  private privateAxiosInstance: AxiosInstance;

  constructor() {
    this.publicAxiosInstance = axios.create({
      baseURL: BASE_URL,
      headers: { ...DEFAULT_HEADERS },
      timeout: API_REQUEST_TIMEOUT,
    });

    this.privateAxiosInstance = axios.create({
      baseURL: BASE_URL,
      headers: { ...DEFAULT_HEADERS },
      timeout: API_REQUEST_TIMEOUT,
    });

    this.privateAxiosInstance.interceptors.request.use((config: any) => {
      const token = storageService.get('accessToken');
      if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    this.privateAxiosInstance.interceptors.response.use(
      (response: any) => response,
      (error) => {
        const { response: { data: { code = null, message = '' } = {} } = {} } = error;
        if (code === 401 || (error.response && error.response.status === 401)) {
          if (typeof message === 'string' && message.includes('expired')) {
            authService.signOut();
          }
        }
        return Promise.reject(error);
      },
    );
  }

  public setAuth(isAuth = false) {
    if (isAuth) return this.privateAxiosInstance;
    return this.publicAxiosInstance;
  }

  public withoutToken() {
    return axios.create({
      baseURL: BASE_URL,
      headers: { ...DEFAULT_HEADERS },
      timeout: API_REQUEST_TIMEOUT,
    });
  }
}

const axiosServiceInstance = new AxiosService();
export { axiosServiceInstance as axiosService };
